'use strict';

import React, { Component } from 'react'

import { search, capitalize, getOnlineType } from '@root/utility'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import PartnersMap from '@/Maps/PartnersMap'

import Config from '@Config/Catalog/show_product'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'
import Image     from '@Pure/Image'
import Link      from '@Pure/Link'
import Logo      from '@Pure/Logo'

const delay_options = Config.fields['online_type'].options
.filter(opt => opt.value !== 'none');

const { app, qwest } = window;

export default class GiftProductsPage extends Component
{
	state =
	{
		data: [],
		references: [],
		place_themes: [],

		pagination:
		{
			max_items: 30,
			limit: 30,
			skip: 0
		},

		searched:
		{
			value: ''
		}
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;
		const state = this.state;

		app.resetFunctions();

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'product',

			filter_query: JSON.stringify(
			{
				disabled: { '!=': [true, 'true'] },
				'place_themes': '5a664f2b464daed256b231ba'
			})
		})
		.then(function (xhr, response)
		{
			const products = response.data;

			const geocodings = [];

			products.forEach(function (product)
			{
				let themes = (product.theme || []).map(function (theme_id)
				{
					let theme = state.references
					.find(infos => infos.model === 'showtheme');

					theme = theme ? theme.data : [];

					theme = theme.find(theme => theme.id === theme_id);

					return theme;
				});

				product._theme = themes;

				if (product.national_brand && !product._national_brand)
				{
					let national_brand = app.getReferedValue(
					{
						model: 'NationalBrand'.toLowerCase(),
						references: response.references || [],
						id: product.national_brand
					});

					if (national_brand?.id)
					{
						product._national_brand = national_brand;
					}

					(national_brand?.addresses || [])
					.filter(address => address.position)
					.forEach(function (address)
					{
						const { lat, lng } = address.position;

						if (lat !== undefined && lng !== undefined)
						{
							geocodings.push(
							{
								PROVIDER: 'GOUV',

								id: address.id,

								data: address.position,

								partners: [{ ...national_brand, __is_brand: true }]
							});
						}
					});
				}
			});

			component.setState(
			{
				loading: false,
				data: products,
				references: response.references || [],
				geocodings: geocodings
			});
		});

		qwest.post('/CMS/getAll',
		{
			model: 'PlaceTheme'.toLowerCase()
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				place_themes: response.data
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			searched:
			{
				value: value,
				data: (search ? search.data : undefined)
			}
		});

		app.emit('searchChange');
	}

	handleOnlineTypeChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ online_type: e.target.value });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader"
				bemit={ ['primary', 'bg-light', 'medium', 'Products'] }
			/>
		)
		: undefined;

		let artists = state.references.find(data => data.model === 'artist');

		artists = artists ? artists.data : [];

		let data = state.data || [];

		data.filter(product => (product.places || []).length > 0)
		.forEach(function (product)
		{
			product._places = undefined;

			(product.places || []).forEach(function (place_id)
			{
				let place = state.references
				.find(infos => infos.model === 'place')
				.data.find(place => place.id === place_id);

				if (place)
				{
					product._places = product._places || [];

					product._places.push(place);
				}
			});
		});

		data
		.filter(product => (product._places || []).length > 0)
		.forEach(function (product)
		{
			product._place_themes = undefined;

			(product._places || []).forEach(function (place)
			{
				(place.place_themes || []).forEach(function (theme_id)
				{
					let place_theme = state.place_themes
					.find(theme => theme.id === theme_id);

					if (place_theme)
					{
						product._place_themes = product._place_themes || [];

						let duplicate = product._place_themes
							.find(theme => theme.id === place_theme.id);

						if (typeof duplicate === 'undefined')
						{
							product._place_themes.push(place_theme);
						}
					}
				});
			});
		});

		if (state.online_type && state.online_type !== 'all')
		{
			data = data.filter(product => product.online_type === state.online_type);
		}

		if (state.searched.value !== '')
		{
			data = data.filter(function (product)
			{
				let matches = 0;

				['name', '_places']
				.forEach(function (field)
				{
					if (!product[field]) return;

					if (field === '_places' && product[field] instanceof Array)
					{
						product[field].forEach(function (place)
						{
							matches += search(place.name, state.searched.value);
						});
					}
					else if (product[field])
					{
						matches += search(product[field], state.searched.value);
					}
				});

				product.__search_matches = matches;

				return matches > 0;
			})
			.sort(function (a, b)
			{
				return a.__search_matches > b.__search_matches;
			});
		}
		else
		{
			data = data
			.sort(function (a, b)
			{
				return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
			});
		}

		let themes = state.references
		.find(infos => infos.model === 'showtheme');

		themes = themes && themes.data ? themes.data : [];

		themes = themes.sort(function (a, b)
		{
			return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
		})
		.map(function (theme)
		{
			let output =
			(
				<option value={ theme.id } key={ theme.id }>{ theme.label }</option>
			);

			return output;
		});

		let products = data
		.map(function (product, key)
		{
			let themes, places, lower_price;

			let artist = artists.find(data => data.id === product.artist);

			if (product._theme.length)
			{
				themes = product._theme
				.filter(function (theme)
				{
					if (!theme)
					{
						return false;
					}

					return true;
				})
				.map(function (theme, key)
				{
					let output =
					(
						<div className="c-model-preview__theme" key={ key }>
							{ theme.label }
						</div>
					);

					return output;
				});

				themes =
				(
					<div className="c-model-preview__themes">
						{ themes }
					</div>
				);
			}

			let displayed_places = (product._places || []).map(function (place, i)
			{
				let string = '';

				if (i > 0)
				{
					string += ', ';
				}

				if (product._places.length <= 2)
				{
					string += place.name;
				}
				else if (place.address && place.address instanceof Object)
				{
					place.address = place.address || { };

					if (place.address.city)
					{
						string = capitalize(place.address.city);
					}

					if (place.address.zip_code)
					{
						string += ' (' + place.address.zip_code.slice(0, 2) + ')';
					}
				}

				return string;
			});

			if (product._places)
			{
				places =
				(
					<div className="c-model-preview__places">
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ displayed_places }
					</div>
				);
			}

			let short_description = (product.description || '').split('<br>').join('');

			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } } />
			);

			let thumbnail;

			if (product.images[0])
			{
				thumbnail = product.images[0].url;
			}
			else if (artist && artist.images[0])
			{
				thumbnail = artist.images[0].url;
			}

			if (thumbnail)
			{
				thumbnail =
				(
					<Image className="c-model-preview__img" src={ thumbnail } />
				);
			}
			else
			{
				thumbnail =
				(
					<Logo className="c-model-preview__img default" type="svg"
						synergies={ true } />
				);
			}

			const online_type = getOnlineType(product.online_type);

			let output =
			(
				<div className="c-model-preview-item product o-grid__item u-flex"
					key={ product.id + key }>

					<div className="c-model-preview c-model-preview--product">
						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/catalogue/' + product.id }>
								{ thumbnail }
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/catalogue/' + product.id }
								className="c-model-preview__title-link">
								{ product.name }
							</Link>
						</h2>

						{ themes }

						{
							online_type ?
							(
								<div className="c-model-preview__online-type">
									{ online_type }
								</div>
							)
							: undefined
						}

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							{ places }

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/catalogue/' + product.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Fiche produit
								</Link>
							</div>

						</div>
					</div>

				</div>
			);

			return output;
		});

		const map = Array.isArray(state.geocodings) ?
		(
			<PartnersMap geocodings={ state.geocodings } />
		)
		: undefined;

		const options = delay_options.map(function ({ value, label='' })
		{
			return (
				<option value={ value } key={ value }>{ label }</option>
			);
		});

		var output =
		(
			<Layout history={ props.history } page_title="Bons d'achat">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">
								Bons d'achat disponibles
							</h2>
						</div>

						{ map }

						<div className="front-dashboard-search">

							<SearchBar className="c-searchbar c-searchbar--front"
								hide_btn={ true } placeholder="Recherche..."
								data={ [] }
								handleChange={ component.handleSearch }
								value={ state.searched.value }
							/>

							<div className="front-dashboard-search__theme-label">
								Délai de livraison
							</div>

							<select className="c-form__input
								front-dashboard-search__online-type"
								name="page-search-online-type"
								onChange={ component.handleOnlineTypeChange }
								value={ state.online_type }>
								<option value="all">Tous</option>
								{ options }
							</select>

						</div>

						<div className="u-negative-margin">

							<div className="o-grid-4 u-flex">
								{ loader || products }
							</div>

						</div>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}